// extracted by mini-css-extract-plugin
module.exports = {"root":"eventInformation_root__JgQPM","description":"eventInformation_description__Wctmm","sidebar":"eventInformation_sidebar__ExQ5x","anchor":"eventInformation_anchor__J2ct7"};